import React, { createContext, useContext, useState } from 'react';
import {CustomNodeData} from '../pages/tabs/ReactFlowTab'


import {
    type Edge,
    type Node,
} from '@xyflow/react';



export type DocumentData = {

    // project information
    projectId: number;
    projectName: string;
    projectDescription: string;
    userProfile: any;

    // simulation information
    file_name: string;
    list_of_actions: string[];
    list_of_properties: string[];

    // plots: any[];
    plots: Map<string, any>;
    layoutConfig: any;

    nodes: Node<CustomNodeData>[]
    edges: Edge[];

    nodes_text : any[];
    edges_text : any[];

    // datagrid info
    current_selected_node: number;

    // tables info
    tables: Map<string, any>;
};

type DocumentDataContextType = {
  documentData: DocumentData;
  setDocumentData: React.Dispatch<React.SetStateAction<DocumentData>>;
};

const defaultData: DocumentData = {
  file_name: "",
  list_of_actions: [],
  list_of_properties: [],
  projectId: 0,
  projectName: "",
  projectDescription: "",
  userProfile: null,
  plots: new Map<string, any>(),
  layoutConfig: null,
  nodes: [],
  edges: [],
  nodes_text: [],
  edges_text: [],
  current_selected_node: 0,
  tables: new Map<string, any>(),
};

const DocumentDataContext = createContext<DocumentDataContextType | undefined>(undefined);

export const useDocumentData = () => {
  const context = useContext(DocumentDataContext);
  if (!context) throw new Error("useDocumentData debe usarse dentro de DocumentDataProvider");
  return context;
};

export const DocumentDataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [documentData, setDocumentData] = useState<DocumentData>(defaultData);

  return (
    <DocumentDataContext.Provider value={{ documentData, setDocumentData }}>
      {children}
    </DocumentDataContext.Provider>
  );
};